export default {
  bonds: {
    is: 'Skuldabréf',
    en: 'Bonds',
  },
  marketToday: {
    is: 'Markaðurinn í dag',
    en: 'Market today',
  },
  trades: {
    is: 'Viðskipti dagsins',
    en: 'Today’s trades',
  },
  nasdaq: {
    is: 'Kauphöll Íslands',
    en: 'Nasdaq OMX Iceland',
  },
  disclaimer: {
    is: 'Kauphöll Íslands | Upplýsingar eru a.m.k. 15 mínútna gamlar',
    en: 'Nasdaq OMX Iceland | Data delayed by 15 min.',
  },
  indexed: {
    is: 'Verðtryggt',
    en: 'Indexed',
  },
  nonIndexed: {
    is: 'Óverðtryggt',
    en: 'Non-indexed',
  },
  yield: {
    is: 'Ávöxtunarkrafa',
    en: 'Last yield',
  },
  bidYield: {
    is: 'Kaupkrafa',
    en: 'Bid yield',
  },
  askYield: {
    is: 'Sölukrafa',
    en: 'Ask yield',
  },
  price: {
    is: 'Verð',
    en: 'Price',
  },
  bidPrice: {
    is: 'Kaupverð',
    en: 'Bid price',
  },
  askPrice: {
    is: 'Söluverð',
    en: 'Ask price',
  },
  highestPrice: {
    is: 'Hæsta verð',
    en: 'Highest price',
  },
  lowestPrice: {
    is: 'Lægsta verð',
    en: 'Lowest price',
  },
  numberOfTrades: {
    is: 'Fjöldi',
    en: 'No.',
  },
  nominalValue: {
    is: 'Nafnverð',
    en: 'Nominal value',
  },
  turnover: {
    is: 'Velta (þús. ISK)',
    en: 'Turnover (ISK thousand)',
  },
  priceChange: {
    is: 'Verðbreyting',
    en: 'Price change',
  },
  duration: {
    is: 'Líftími',
    en: 'Modified duration, years',
  },
  bond: {
    is: 'Bréf',
    en: 'Bond',
  },
  value: {
    is: 'Virði',
    en: 'Value',
  },
  time: {
    is: 'Tími',
    en: 'Time',
  },
  selectInformation: {
    is: 'Veldu upplýsingar',
    en: 'Select information',
  },
};
